import { CardContainer } from "@/components/commons/CardContainer";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { Input } from "@/components/elements/Input";
import { EMPTY_STR } from "@/constants/string";
import { black, text } from "@/theme/colors";
import { Stack, Typography, styled } from "@mui/material";
import { ChangeEvent, FC, useEffect, useState } from "react";

type TMockExamInfo = {
  name: string;
  examDuration: number | null;
  totalScore: number | null;
  passingScore: number | null;
  internalMemo: string | null;
  onMemoBlur?: (value: string) => void;
  isSavingMemo?: boolean;
};

type TMockExamInfoCardProps = {
  info: TMockExamInfo;
};

// Displays mock exam basic information in a card layout (matches design Frame 1000005233)
export const MockExamInfoCard: FC<TMockExamInfoCardProps> = ({ info }) => {
  const [memoValue, setMemoValue] = useState(info.internalMemo ?? "");
  const mockExamName = info.name?.trim() ? info.name : EMPTY_STR.TEXT;

  useEffect(() => {
    setMemoValue(info.internalMemo ?? "");
  }, [info.internalMemo]);

  const handleMemoChange = (e: ChangeEvent<HTMLInputElement>) => {
    setMemoValue(e.target.value);
  };

  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="head20Bold">試験情報</Typography>
        <ItemInfo label="模擬試験名" value={mockExamName} />
        <InfoRow>
          <InfoItem>
            <ItemInfo
              label="試験時間"
              value={info.examDuration != null ? String(info.examDuration) : ""}
              endIcon={
                <Typography variant="body14" color={text.primary}>
                  分
                </Typography>
              }
            />
          </InfoItem>
          <InfoItem>
            <ItemInfo
              label="合格ライン（点数）"
              value={info.passingScore != null ? String(info.passingScore) : ""}
              endIcon={
                <Typography variant="body14" color={text.primary}>
                  点
                </Typography>
              }
            />
          </InfoItem>
          <InfoItem>
            <ItemInfo
              label="満点"
              value={info.totalScore != null ? String(info.totalScore) : ""}
              endIcon={
                <Typography variant="body14" color={text.primary}>
                  点
                </Typography>
              }
            />
          </InfoItem>
        </InfoRow>
        <Stack gap={1}>
          <Typography variant="cap12" color={black[70]}>
            社内メモ
          </Typography>
          <Input nonControl value={memoValue} onChange={handleMemoChange} onBlur={() => info.onMemoBlur?.(memoValue)} placeholder="" clearable />
        </Stack>
      </Stack>
    </CardContainer>
  );
};

const InfoRow = styled(Stack)`
  flex-direction: row;
  gap: 24px;
`;

const InfoItem = styled(Stack)`
  flex: 1;
  gap: 4px;
`;
